import { createStore } from 'vuex'

import * as Step from '@/store/modules/Step';
import * as OrderId from '@/store/modules/OrderId';
import * as ChooseProducts from '@/store/modules/ChooseProducts';
import * as OrderData from '@/store/modules/OrderData';
import * as Signature from '@/store/modules/Signature';
import * as Products from '@/store/modules/Products';
import * as Cookie from '@/store/modules/Cookie';

const store = createStore({
    modules: {
        Step,
        ChooseProducts,
        OrderData,
        Signature,
        Products,
        Cookie,
        OrderId
    }
})

export default store;
